import { render, staticRenderFns } from "./PDM80.vue?vue&type=template&id=355a550f&lang=pug"
import script from "./PDM80.vue?vue&type=script&lang=js"
export * from "./PDM80.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports